import {
  ArticleSideBarModule,
  ArticleSidebarItemModule,
  CardModule,
  CarouselSliderModule,
  MediaCardModule,
  SideBarModule,
  StaggeredContentModule,
  ThumbnailModule,
  VideoModule,
  HighlightBlockModule,
  LegalModule,
  SectionTitleModule,
  ArticleInfoModule,
  ListModule,
  DividerModule,
  PromoCardModule,
  PaddingModule,
} from '@frk/eds-components';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { ArticleComponent } from './article.component';
import { TextBlockModule } from '@marketing/content-blocks/text-block/text-block.module';
import { AvatarBlockModule } from '@marketing/content-blocks/avatar-block/avatar-block.module';
import { TitleBlockModule } from '@marketing/content-blocks/title-block/title-block.module';
import { ImageBlockModule } from '@marketing/content-blocks/image-block/image-block.module';
import { BlockQuoteBlockModule } from '@marketing/content-blocks/blockquote-block/blockquote-block.module';
import { MarketoFormModule } from '@marketing/marketo-form/marketo-form.module';
import { InsightsModule } from '@marketing/insights/insights.module';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { PipesModule } from '../../shared/pipes/pipes.module';

@NgModule({
  declarations: [ArticleComponent],
  imports: [
    ArticleSideBarModule,
    ArticleSidebarItemModule,
    BrSdkModule,
    CardModule,
    CarouselSliderModule,
    CommonModule,
    LegalModule,
    MediaCardModule,
    PromoCardModule,
    RouterModule,
    SharedModule,
    SideBarModule,
    StaggeredContentModule,
    ThumbnailModule,
    NgxSkeletonLoaderModule,
    AvatarBlockModule,
    TextBlockModule,
    TitleBlockModule,
    ImageBlockModule,
    BlockQuoteBlockModule,
    VideoModule,
    HighlightBlockModule,
    InsightsModule,
    SectionTitleModule,
    ArticleInfoModule,
    ListModule,
    PipesModule,
    DividerModule,
    MarketoFormModule,
    PaddingModule,
  ],
  exports: [ArticleComponent],
  entryComponents: [ArticleComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

/**
 * Article Module
 */
export class ArticleModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      Article: ArticleComponent,
    };
  }
}
